import { styled } from "@mui/material/styles";

export const HeadContainer = styled("div")(({ theme }) => ({
  borderBottom: `0.0625rem solid ${theme.palette.custom.grey.border}`,
  paddingBottom: "8px",
  display: "flex",
  justifyContent: "space-between",
}));
